import { FC } from "react"
import { SafetiesClone } from "../../../module/safeties/containers/clone"

export const SafetiesClonePage: FC = () => <SafetiesClone />
